import React, { useEffect, useRef } from 'react'
import './Privacy.css'

const sections = [
  {
    heading: 'What personal information do we collect from the people that visit our blog or website?',
    body: 'When registering on our site, as appropriate, you may be asked to enter your name, email address or other details to help you with your experience.',
  },
  {
    heading: 'When we collect information',
    body: 'We collect information from you when you enter information on our site or provide us with feedback on our products or jewellery purchase scheme.',
  },
  {
    heading: 'How we use your information',
    body: 'We may use the information we collect from you when you register, make a purchase, sign up for our newsletter, respond to a survey or marketing communication, surf the website, or use certain other site features in the following ways:',
    list: [
      'To improve our website in order to better serve you',
      'To allow us to better service you in responding to your customer service requests',
    ],
  },
  {
    heading: 'Security',
    body: 'We are committed to ensuring that your information is secure. In order to prevent unauthorised access or disclosure, we have put in place suitable physical, electronic and managerial procedures to safeguard and secure the information we collect online.',
  },
  {
    heading: 'How we use cookies',
    body: `A cookie is a small file which asks permission to be placed on your computer's hard drive. Once you agree, the file is added and the cookie helps analyse web traffic or lets you know when you visit a particular site.\n\nCookies allow web applications to respond to you as an individual. The web application can tailor its operations to your needs, likes and dislikes by gathering and remembering information about your preferences.\n\nWe use traffic log cookies to identify which pages are being used. This helps us analyse data about web page traffic and improve our website in order to tailor it to customer needs. We only use this information for statistical analysis purposes.\n\nOverall, cookies help us provide you with a better website, by enabling us to monitor which pages you find useful and which you do not. A cookie in no way gives us access to your computer or any information about you, other than the data you choose to share with us.`,
  },
  {
    heading: 'Third-party disclosure',
    body: 'We do not sell, trade, or otherwise transfer to outside parties your Personally Identifiable Information.',
  },
  {
    heading: 'Unsubscribing',
    custom: (
      <p>
        If at any time you would like to unsubscribe from receiving future emails, you can email us at{' '}
        <a href="mailto:mkmthangamaligai@gmail.com">mkmthangamaligai@gmail.com</a> and we will promptly
        remove you from ALL correspondence.
      </p>
    ),
  },
]

const Privacy = () => {
  const heroRef = useRef(null)
  const introRef = useRef(null)
  const sectionRefs = useRef([])

  useEffect(() => {
    const targets = [heroRef.current, introRef.current, ...sectionRefs.current].filter(Boolean)

    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) entry.target.classList.add('visible')
        })
      },
      { threshold: 0.1 }
    )

    targets.forEach((el, i) => {
      el.style.transitionDelay = `${i * 0.08}s`
      observer.observe(el)
    })

    return () => observer.disconnect()
  }, [])

  return (
    <div className="privacy-wrapper">
      {/* Hero */}
      <div className="privacy-hero" ref={heroRef}>
        <h1>P<span className='SmallLetter'>rivacy</span> P<span className='SmallLetter'>olicy</span></h1>
      </div>

      {/* Body */}
      <div className="privacy-body">
        {/* Intro */}
        <p className="privacy-intro" ref={introRef}>
          This privacy policy has been compiled to better serve those who are concerned with how their
          'Personally Identifiable Information' (PII) is being used online. PII is information that can
          be used on its own or with other information to identify, contact, or locate a single person,
          or to identify an individual in context. Please read our privacy policy carefully to get a
          clear understanding of how we collect, use, protect or otherwise handle your Personally
          Identifiable Information in accordance with our website.
        </p>

        {/* Sections */}
        {sections.map((sec, i) => (
          <div
            key={i}
            className="privacy-section"
            ref={(el) => (sectionRefs.current[i] = el)}
          >
            <h2>{sec.heading}</h2>

            {sec.custom
              ? sec.custom
              : sec.body
              ? sec.body.split('\n\n').map((para, pi, arr) => (
                  <p key={pi} style={{ marginBottom: pi < arr.length - 1 ? '12px' : 0 }}>
                    {para}
                  </p>
                ))
              : null}

            {sec.list && (
              <ul>
                {sec.list.map((item, li) => (
                  <li key={li}>{item}</li>
                ))}
              </ul>
            )}
          </div>
        ))}
      </div>
    </div>
  )
}

export default Privacy